export default function omit(k, obj) {
  const recursive = (keyList, _obj) => {
    if (keyList.length === 0) return _obj
    delete _obj[keyList[0]]
    return recursive(keyList.slice(1), _obj)
  }
  return recursive(k, { ...obj })
}
